

export function draw_agent(data) {

	let agent = data.agent;
	// Check if data is valid
	if (!agent || agent.loading) {
		console.error('Error: data is null or undefined');
		$('.agency_block .company_name').html(''); // Provide a fallback
		if (agent?.loading) {
			$('.agency_block .company_name').html('Loading...');
		}
		$('.agency_block .email').html(''); // Provide a fallback
		$('.agency_block .first_name').html(''); // Provide a fallback
		$('.agency_block .last_name').html(''); // Provide a fallback


		return;
	}

	// Check for the existence of the expected properties
	if (agent.company_name) {
		$('.agency_block .company_name').html(agent.company_name);
		$('.agency_select .select2-selection__rendered').text('['+agent.email+'] ' + agent.company_name);
	} else {
		console.warn('Warning: company_name is missing in data');
		$('.agency_block .company_name').html(''); // Provide a fallback
	}

	if (agent.email) {
		$('.agency_block .email').html(agent.email);
	} else {
		console.warn('Warning: email is missing in data');
		$('.agency_block .email').html(''); // Provide a fallback
	}

	if (agent.first_name) {
		$('.agency_block .first_name').html(agent.first_name);
	} else {
		console.warn('Warning: first_name is missing in data');
		$('.agency_block .first_name').html(''); // Provide a fallback
	}

	if (agent.last_name) {
		$('.agency_block .last_name').html(agent.last_name);
	} else {
		console.warn('Warning: last_name is missing in data');
		$('.agency_block .last_name').html(''); // Provide a fallback
	}

}
